import { useScrollReveal } from '@/hooks/use-scroll-reveal';

const LeadersInvitation = () => {
  const eyebrow = useScrollReveal<HTMLDivElement>();
  const heading = useScrollReveal<HTMLHeadingElement>();
  const body = useScrollReveal<HTMLDivElement>();

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-background via-secondary/40 to-background py-32 sm:py-44">
      {/* Painterly cream wash — radial */}
      <div
        className="absolute inset-0 opacity-60 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse at 30% 20%, hsl(var(--primary) / 0.06) 0%, transparent 55%), radial-gradient(ellipse at 70% 80%, hsl(var(--sage) / 0.05) 0%, transparent 50%)',
        }}
        aria-hidden="true"
      />

      <div className="container-mobile relative z-10 max-w-5xl mx-auto">
        {/* Asymmetric eyebrow */}
        <div
          ref={eyebrow.ref}
          className={`flex items-center gap-4 mb-10 transition-all duration-700 ${
            eyebrow.visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <span className="h-px w-12 bg-primary" aria-hidden="true" />
          <p className="text-primary font-semibold tracking-[0.25em] uppercase text-xs">
            The Invitation
          </p>
        </div>

        {/* Editorial heading */}
        <h2
          ref={heading.ref}
          className={`text-foreground text-4xl sm:text-5xl lg:text-6xl mb-16 max-w-4xl leading-[1.05] transition-all duration-1000 ${
            heading.visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
          style={{ textWrap: 'balance' }}
        >
          You probably already <span className="text-primary italic">know.</span>
        </h2>

        {/* Body — clean single column, no decorative quote glyph */}
        <div
          ref={body.ref}
          className={`max-w-3xl space-y-7 text-foreground/85 text-lg sm:text-xl leading-relaxed font-light transition-all duration-1000 delay-200 ${
            body.visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <p>
            You've reached a level where the moves that got you here don't quite work the same way anymore. The wins are still coming. The applause is still loud. And something underneath is asking a different question.
          </p>
          <p>
            You sense the next version of you is asking something the current version doesn't yet know how to give. The next move is interior. More honest. More yours.
          </p>
          <p>
            And you need a thinking partner who isn't on your payroll, your board, or your dinner table. Someone who can hold the whole of it with you, week after week, without flinching and without fixing.
          </p>
        </div>
      </div>
    </section>
  );
};

export default LeadersInvitation;
